import { makeStyles } from '@material-ui/core'

export default makeStyles ((theme) =>({
  media:{
    height: '250px',
    width: '300px,'
  }
}))